'use client';

import { Box, Typography, Link, Stack } from '@mui/material';
import styled from '@emotion/styled';
import { color, spacing } from '@/theme/tokens';

const DepartmentContainer = styled(Box)`
    
`;

const EmailLink = styled(Link)`
    display: inline-block;
    text-decoration: underline;
    color: ${color.brand[50]} !important;
    width: fit-content;
`;

type DepartmentContactProps = {
    name: string;
    description: string;
    emails: string[];
};

export default function DepartmentContact({ name, description, emails }: DepartmentContactProps) {
    return (
        <DepartmentContainer>
            <Typography component="h4" variant="label5semibold" sx={{ marginBottom: spacing[8] }}>
                {name}
            </Typography>

            <Typography component="p" variant="label5regular" sx={{ marginBottom: spacing[16] }}>
                {description}
            </Typography>

            <Stack direction="column" gap={spacing[6]}>
                {emails.map((email, index) => (
                    // Static, non-reordered list built from derived data — index keys are stable here.
                    // react-doctor-disable-next-line no-array-index-as-key
                    <EmailLink key={index} href={`mailto:${email}`}>
                        <Typography variant="label5regular" color={color.brand[50]}>
                            {email}
                        </Typography>
                    </EmailLink>
                ))}
            </Stack>
        </DepartmentContainer>
    );
}
